import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { loadTranslationsOnBootstrap } from '@lx/shared/app-init';
import { resolveLocale, saveLocaleToStorage } from '@lx/shared/app-init/functions/locale-initializer.functions';
import { WEBAPP_PREFIX } from '@lx/shared/storage';
import { RuntimeEnvironment } from '@lx/shared/types';
import { AppComponent } from './app/app.component';
import { getAppConfig } from './app/app.config';
import { COMPANY_STORAGE_KEY, LOCALE_STORAGE_KEY, OnlineQtInitQueryParametersEnum, STORE_RESET_KEY } from './app/types';
import { environment } from './environments/environment';
import { handleCompanyChange, resolveCompany, saveCompanyToStorage } from '@lx/quote-tool/lite/shared/utils';

if (environment.production) {
  enableProdMode();
}

const localeStorageKey = `${WEBAPP_PREFIX}${LOCALE_STORAGE_KEY}`;

// Create runtime environment without mutating the imported environment object
const runtimeEnvironment: RuntimeEnvironment = {
  ...environment,
  LOCALE: resolveLocale(OnlineQtInitQueryParametersEnum.Locale, environment.LOCALE, localeStorageKey),
  COMPANY: resolveCompany(environment.COMPANY, COMPANY_STORAGE_KEY, environment.SUPPORTED_COMPANIES),
};

// Check if company has changed and flag for store reset if needed
handleCompanyChange(runtimeEnvironment.COMPANY, COMPANY_STORAGE_KEY, STORE_RESET_KEY);

loadTranslationsOnBootstrap(runtimeEnvironment, () => {
  bootstrapApplication(AppComponent, getAppConfig(runtimeEnvironment)).catch((err) => console.error(err));
}).finally(() => {
  // Store the definitive locale (original or fallback) and company in sessionStorage to persist them across page reloads
  saveLocaleToStorage(runtimeEnvironment.LOCALE, localeStorageKey);
  saveCompanyToStorage(runtimeEnvironment.COMPANY, COMPANY_STORAGE_KEY);
});
